
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
import { Utiles } from '@/__env/pluggins/event-bus';
import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }
        public get Coeficiente() { return this.Controlador.Coeficiente; }
        public get Modo() { return this.Controlador.Vista.Modo; }
        public set Modo( x: string ) { this.Controlador.Vista.Modo = x; }

        public Abierto: boolean = false;

        public Busqueda: string = '';
        @Watch( 'Busqueda' )
        onBusqueda()
        {
            if ( !this.Busqueda )
                this.Buscar( true );
        }

        public Buscar( forzar?: boolean )
        {
            if ( forzar )
                this.Busqueda = '';

            this.Buscador.Parametros.q = this.Busqueda;
            this.Buscador.Buscar( 1 );
        }

        Seleccionar( x: number )
        {

            this.Buscador.Buscar( 1 );
            this.Refrescar();
        }

        public Refresh: boolean = true;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }

        async Ejecutar()
        {
            if ( await Utiles.Mensajes.SiNo( 'Modificar precios', '¿Está seguro de modificar los precios de las publicaciones seleccionadas? Este proceso no puede cancelarse.' ) )
            {
                this.Controlador.Ejecutar();
            }
        }
    }
